/**
 * Build time configurations of the api base urls.
 */
let api: {
  gyldendalAccessService: (version: "v1" | "v2" | undefined) => string;
};

switch (process.env.APP_ENV ?? process.env.NODE_ENV) {
  case "production":
    api = {
      gyldendalAccessService: (version: "v1" | "v2" | undefined) =>
        `https://gdapim-production.azure-api.net/GAS-${version ?? "v"}-Prod/${
          version ?? "v"
        }`,
    };
    break;

  case "staging":
    api = {
      gyldendalAccessService: (version: "v1" | "v2" | undefined) =>
        `https://gdapim-production.azure-api.net/GAS-${version ?? "v"}-QA/${
          version ?? "v"
        }`,
    };
    break;

  default:
    api = {
      gyldendalAccessService: (version: "v1" | "v2" | undefined) =>
        `https://dev-apim.gyldendal.dk/GAS-${version ?? "v"}-Test/${
          version ?? "v"
        }`,
    };
}

export { api };
